import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeroiconsOutlineThumbUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 90,
	height: 90,
	viewBox: "0 0 90 90",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M52.5 37.5H70.365C71.6432 37.5 72.9003 37.8268 74.0167 38.4492C75.1332 39.0716 76.0721 39.9691 76.7442 41.0564C77.4163 42.1436 77.7994 43.3847 77.8571 44.6616C77.9148 45.9386 77.6451 47.2091 77.0737 48.3525L63.9487 74.6025C63.3257 75.8492 62.3677 76.8977 61.182 77.6303C59.9963 78.3629 58.63 78.7506 57.2362 78.75H42.1725C41.5575 78.75 40.9512 78.675 40.3537 78.525L26.25 75M52.5 37.5V18.75C52.5 16.7609 51.7098 14.8532 50.3033 13.4467C48.8968 12.0402 46.9891 11.25 45 11.25H44.6437C42.7687 11.25 41.25 12.7687 41.25 14.6437C41.253 17.3219 40.4593 19.9404 38.97 22.1662L26.25 41.25V75M52.5 37.5H45M26.25 75H18.75C16.7609 75 14.8532 74.2098 13.4467 72.8033C12.0402 71.3968 11.25 69.4891 11.25 67.5V45C11.25 43.0109 12.0402 41.1032 13.4467 39.6967C14.8532 38.2902 16.7609 37.5 18.75 37.5H28.125",
		stroke: "#79C912",
		strokeWidth: 6,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHeroiconsOutlineThumbUp;
